import React, { useState  } from "react";
import Switch from "react-switch";

const CheckboxComponent = ({ isOn, onChange, id, className}) => {
    return (
        <Switch 
        onChange={onChange}
        checked={isOn}
        className={className}
        id={id}
        />
    )
}

export default CheckboxComponent